"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = useCommon;
const tslib_1 = require("tslib");
const broswer = tslib_1.__importStar(require("@futuweb/tool-browser"));
const vue_demi_1 = require("vue-demi");
function useCommon() {
    var _a, _b, _c, _d;
    const uid = ((_d = (_c = (_b = (_a = require('@futuweb/fego-render')) === null || _a === void 0 ? void 0 : _a.store) === null || _b === void 0 ? void 0 : _b.variable) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.UID) || 0;
    const isPlatform = broswer.isNNPlatform();
    // const launchMM = require('@futuweb/fego-render')?.common?.utils?.launchMM;
    return {
        uid,
        isPlatform,
        /**
         * 打开弹窗
         * @param tplId
         */
        openDialog(tplId) {
            const that = (0, vue_demi_1.getCurrentInstance)();
            const { common: { behavior: { runBehaviour } } } = require('@futuweb/fego-render');
            runBehaviour(that, {
                type: 'operateComponent',
                value: '',
                tplId,
                methodName: 'open'
            });
        },
        // 登录
        jumpLogin(options) {
            const { common: { behavior: { runBehaviour } } } = require('@futuweb/fego-render');
            runBehaviour(this, Object.assign({
                type: 'login',
                value: location.href,
                withQuery: true,
                customData: 'invite'
            }, options));
        },
        /**
         * 更新fego变量
         * @param key
         * @param value
         */
        updateFegoVariable(key, value) {
            const { store: { variable: { data } } } = require('@futuweb/fego-render');
            console.log(`更新页面变量 key: ${key}, value: ${value}`);
            data[key] = value;
        }
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tbW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiY29tbW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBRUEsNEJBNERDOztBQTlERCx1RUFBaUQ7QUFDakQsdUNBQThDO0FBQzlDLFNBQXdCLFNBQVM7O0lBQzdCLE1BQU0sR0FBRyxHQUFXLENBQUEsTUFBQSxNQUFBLE1BQUEsTUFBQSxPQUFPLENBQUMsc0JBQXNCLENBQUMsMENBQUUsS0FBSywwQ0FBRSxRQUFRLDBDQUFFLElBQUksMENBQUUsR0FBRyxLQUFJLENBQUMsQ0FBQztJQUNyRixNQUFNLFVBQVUsR0FBWSxPQUFPLENBQUMsWUFBWSxFQUFFLENBQUM7SUFDbkQsNkVBQTZFO0lBQzdFLE9BQU87UUFDSCxHQUFHO1FBQ0gsVUFBVTtRQUNWOzs7V0FHRztRQUNILFVBQVUsQ0FBQyxLQUFhO1lBQ3BCLE1BQU0sSUFBSSxHQUFHLElBQUEsNkJBQWtCLEdBQUUsQ0FBQztZQUNsQyxNQUFNLEVBQ0YsTUFBTSxFQUFFLEVBQ0osUUFBUSxFQUFFLEVBQUUsWUFBWSxFQUFFLEVBQzdCLEVBQ0osR0FBRyxPQUFPLENBQUMsc0JBQXNCLENBQUMsQ0FBQztZQUNwQyxZQUFZLENBQUMsSUFBSSxFQUFFO2dCQUNmLElBQUksRUFBRSxrQkFBa0I7Z0JBQ3hCLEtBQUssRUFBRSxFQUFFO2dCQUNULEtBQUs7Z0JBQ0wsVUFBVSxFQUFFLE1BQU07YUFDckIsQ0FBQyxDQUFDO1FBQ1AsQ0FBQztRQUNELEtBQUs7UUFDTCxTQUFTLENBQUMsT0FBYTtZQUNuQixNQUFNLEVBQ0YsTUFBTSxFQUFFLEVBQ0osUUFBUSxFQUFFLEVBQUUsWUFBWSxFQUFFLEVBQzdCLEVBQ0osR0FBRyxPQUFPLENBQUMsc0JBQXNCLENBQUMsQ0FBQztZQUNwQyxZQUFZLENBQ1IsSUFBSSxFQUNKLE1BQU0sQ0FBQyxNQUFNLENBQ1Q7Z0JBQ0ksSUFBSSxFQUFFLE9BQU87Z0JBQ2IsS0FBSyxFQUFFLFFBQVEsQ0FBQyxJQUFJO2dCQUNwQixTQUFTLEVBQUUsSUFBSTtnQkFDZixVQUFVLEVBQUUsUUFBUTthQUN2QixFQUNELE9BQU8sQ0FDVixDQUNKLENBQUM7UUFDTixDQUFDO1FBQ0Q7Ozs7V0FJRztRQUNILGtCQUFrQixDQUFJLEdBQVcsRUFBRSxLQUFRO1lBQ3ZDLE1BQU0sRUFDRixLQUFLLEVBQUUsRUFDSCxRQUFRLEVBQUUsRUFBRSxJQUFJLEVBQUUsRUFDckIsRUFDSixHQUFHLE9BQU8sQ0FBQyxzQkFBc0IsQ0FBQyxDQUFDO1lBQ3BDLE9BQU8sQ0FBQyxHQUFHLENBQUMsZUFBZSxHQUFHLFlBQVksS0FBSyxFQUFFLENBQUMsQ0FBQztZQUNuRCxJQUFJLENBQUMsR0FBRyxDQUFDLEdBQUcsS0FBSyxDQUFDO1FBQ3RCLENBQUM7S0FDSixDQUFDO0FBQ04sQ0FBQyJ9